import React from 'react';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';
import { ToastProvider } from './components/ui/Toast';

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <StripeProvider>
          <Routes />
        </StripeProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;